<template>
  <login-page :warn-explorer="$attrs['warn-explorer']" />
</template>

<script>
import LoginPage from '@containers/Login/LoginPage'

export default {
  components: {
    LoginPage
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/LoginPage.vue